import WxAuth from './WxAuth'
export default WxAuth;